import VideoAiHandler from "./VideoAiHandler";

export default VideoAiHandler